import { useEffect, useState } from 'react'
import { Log4netConfigForm } from '../../Components/log4NetConfigForm'
import { useGetLog4netConfigMutation } from '../../Redux/Admin_Tasks/Log4NetSlice'
import { getBaseUrl } from '../../Utils'
import { Skeleton } from '../../GenericComponents/Skeleton'
import { useTitleContext } from "../../Hooks/useTitleContext";


const ManageLog4netConfig: React.FC = () => {

    const { setTitle } = useTitleContext();
    setTitle("Manage Log4netConfig");

    const [getLog4netConfig, { data: configData, error: configError, isLoading: configLoading }] =
        useGetLog4netConfigMutation()
    const [isRequestComplete, setIsRequestComplete] = useState(false)

    useEffect(() => {
        getLog4netConfig().unwrap()
        setIsRequestComplete(true)
    }, [getLog4netConfig])

    return (
        <>
             <div id="dimension-manager">
                <div className="float-right margin-top-small">
                    <a
                        id="link_backto_admin_tasks"
                        href="#AdminTasks"
                    >
                        &laquo; Back to Admin Tasks
                    </a>
                </div>
                    <Skeleton loading={configLoading} className="log4net-header">
                        <div className="header">Manage Log4net Config</div>
                    </Skeleton>
                </div>
            <br />

            {configError ? (
                <div>Error loading data: {JSON.stringify(configError)}</div>
            ) : !isRequestComplete && !configData ? (
                <div>No data available</div>
            ) : (
                <Skeleton loading={configLoading} height='325px' width='40%'>
                    {configData && <Log4netConfigForm {...configData} />}
                </Skeleton>
            )}
        </>
    )
}

export default ManageLog4netConfig
